
// ROUTES
require('modules/partner/routes/partner');

// CONTROLLERS
require('modules/partner/controllers/partner');
require('modules/partner/controllers/list');
require('modules/partner/controllers/create');
require('modules/partner/controllers/edit');

// SERVICES
require('modules/partner/services/partner');
require('modules/partner/services/list');
require('modules/partner/services/create');
require('modules/partner/services/edit');
require('modules/partner/services/delete');



angular.module('unica_partner', [

	// ROUTES
	'unica_partner.partner_routes',

	// CONTROLLERS
	'unica_partner.partner_controllers',

	// SERVICES
	'unica_partner.partner_services'

]);